export default "__VITE_ASSET__C5ON70UM__"